import React from "react";

const CustomComponent = ({ date, className }) => <time className={className}>{date}</time>;

export default CustomComponent;
